import { Form, Formik } from "formik";
import { useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import { OrderTransport } from "src/app/transports/order";
import { IActionsModal } from "src/app/types/actionsModal";
import { TLangType } from "src/app/types/LangType";

const CreatePopCashCampaignModalContainer = (
    props: IActionsModal<{ lang: TLangType; id: number; url: string; popPrice: number }>
) => {
    const { handleClose = () => {}, entity, updateGridOnSave } = props;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();

    const handleSubmit = async (_value: { popPrice: number }) => {
        setLoading(true);

        try {
            await OrderTransport.createPopCashCampaigns(entity.id, _value.popPrice);
            toast.success(formatMessage({ id: "common.notification.success" }));
            updateGridOnSave && updateGridOnSave({}, true);
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.areYouSure" })}
            handleClose={handleClose}
            loading={loading}
            formId="createCampaign"
            buttonConfirmationLabel={formatMessage({ id: "common.action.confirmation" })}
            showModal={true}
            modalProps={{ size: undefined }}
        >
            <Formik
                initialValues={{
                    popPrice: entity.popPrice || 2.5,
                }}
                onSubmit={handleSubmit}
            >
                <Form id="createCampaign">
                    <Row>
                        <Col sm={3}>
                            <FormLabel>{formatMessage({ id: "common.field.popPrice" })}</FormLabel>
                        </Col>
                        <Col>
                            <SimpleFormControl
                                name="popPrice"
                                type="number"
                                min={0.1}
                                max={5}
                                step={0.1}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3}>Url : </Col>
                        <Col>{entity.url} </Col>
                    </Row>
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default CreatePopCashCampaignModalContainer;
